<template>
    <div style="height:100%;display:flex;flex-direction:column;position:relative">
        <a-icon v-if="isLoading" style="position:absolute;left:50%;top:40%;font-size:30px;color:rgba(24, 144, 255, 1);z-index:1000000" type="loading" />
        <div style="height:60px;background:rgba(34, 215, 187, 1);text-align:center;color:#fff;line-height:60px;padding:0 80px">
            <div style="float:left;font-size:16px;cursor:pointer" @click="backTo">
                <a-icon type="left" />
                <span>返回机器人列表</span>
            </div>
            <span style="font-size:20px;font-weight:bold;">{{name}}</span>
            <div style="float:right;font-size:16px;">
                <span>QA数：{{qaCount}}条</span>
            </div>
        </div>
        <div style="flex:1;overflow-y:auto">
            <ul class="chat-ul">
                <li v-for="(item,index) in chatList" :key='index' :class="{'top-index':item.type=='answer', 'color1':item.questionScore<0.2, 'color2':item.questionScore<0.4&&item.questionScore>0.2||item.questionScore==0.2, 'color3':item.questionScore<0.6&&item.questionScore>0.4||item.questionScore==0.4, 'color4':item.questionScore<0.8&&item.questionScore>0.6||item.questionScore==0.8, 'color5':item.questionScore<1&&item.questionScore>0.8||item.questionScore==1,}" style="position:relative">
                    <div v-if="item.needAddKnowledge==1" class="add-box" @click="addIntoLib(index)">
                        <a-icon style="font-size:18px;" type="plus" />
                        <div>添加到知识库</div>
                    </div>
                    <div v-if="item.needAddKnowledge==2" class="move-box" @click="removeIntoLib(index)">
                        <a-icon style="font-size:18px;" type="minus" />
                        <div>移出<br>知识库</div>
                    </div>
                    <div class="chat-list">
                        <span v-if="item.type=='answer'" class="get-point">{{item.questionScore}}</span>
                        <div v-if="item.type=='question'&&index!=0" class="like-dislike">
                            <a-icon @click="supportIdea(index)" type="like" style="font-size:18px;cursor:pointer" />
                            <!-- <a-icon @click="editAnswer(item,index)" type="dislike" style="font-size:18px;cursor:pointer" /> -->
                        </div>
                        <span v-if="item.type=='answer'" class="avatar-robot avatar">客户</span>
                        <span v-if="item.type=='question'" class="avatar-customer avatar">机器</span>
                        <span class="content" v-if="item.edit==false">
                            <span v-if="item.type=='question'" style="color:rgba(212, 48, 48, 1)">({{item.score}})</span>
                            <span v-if="item.type=='question'">{{item.question}}</span>
                            <span v-if="item.type=='answer'" style="color:#fff">{{item.question}}</span>
                        </span>
                        <div style="display:inline-block;width:855px;position:relative" v-if="item.edit==true">
                            <a-input v-model="currentAnswer" style="height:40px;" placeholder="我不会回答，点击右侧编辑按钮可进行修改" />
                            <a-button @click="showLibrary(index)" style="position:absolute;right:6px;top:4px;" type="primary" icon="bars">
                            从库中选择
                            </a-button>
                        </div>
                        <a-icon @click="editAnswer(item,index)" class="edit" type="edit" v-if="item.type=='question'&&item.edit==false&&index!=0"/>
                        <div class="btn-group" v-if="item.type=='question'&&item.edit==true">
                            <span @click="sureAnswer(index)" class="btn-sure">确定</span>
                            <span @click="offAnswer(index)" class="btn-off">取消</span>
                        </div>
                        <div @click="clickFn" v-if="item.isShow" style="width:948px;height:356px;box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.16);border-radius: 4px;position:absolute;left:52px;top:72px;background:#fff;padding:16px 24px;z-index:2">
                            <a-select mode="tags" style="width: 100%" placeholder="可输入内容搜索" @change="handleChange">
                                <a-select-option v-for="(item1) in selectionList" :key="item1.answer">
                                    <div style="display:flex;width:100%;">
                                        <span style="color:rgba(212, 48, 48, 1);margin-right:23px;font-size:14px;width:25px;display:inline-block;line-height:30px">{{item1.score}}</span>
                                        <span style="background:rgba(188, 202, 214, 0.2);color:rgba(139, 152, 167, 1);font-size:14px;padding:4px;flex:1">{{item1.answer}}</span>
                                    </div>
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div style="height:120px;text-align:center;">
            <div style="position:relative;width:1000px;margin:0 auto;">
                <a-input @focus='focusFn()' @blur="blurFn" v-model="question" @keyup.enter="queryResponse()" :disabled='currentState' :placeholder="placeholderWord" style="height:60px;"/>
                <a-icon @click="queryResponse" style="position:absolute;right:20px;top:14px;font-size:30px;color:rgba(139, 152, 167, 1);cursor:pointer;" type="enter" />
            </div>
        </div>
        <div @click="cleanChat" style="position:absolute;left:24px;bottom:24px;width:48px;;height:48px;border-radius:24px;box-shadow: 0px 2px 10px 0px rgba(122, 0, 0, 0.3);text-align:center;color:rgba(212, 48, 48, 1);font-size:12px;padding-top:6px;cursor:pointer">
            <div>
                <a-icon style="font-size:14px;" type="reload" />
            </div>
            <div>重置</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Index',
        components: {  },
        data() {
            return {
                currentId: '',
                question: '',
                chatList: [],
                currentQuestion: '',
                qaCount: 0,
                selectionList: [],
                lastQuestion: '',
                currentAnswer: '',
                currentState: false,
                name: '',
                times: 0,
                randomNum: 0,
                isLoading: false,
                placeholderWord: "请输入",
                answerNull: false,
            }
        },
        methods: {
            focusFn() {
                this.placeholderWord = ''
            },
            blurFn() {
                this.placeholderWord = '请输入'
            },
            queryResponse() {
                if(this.times == 0){
                    this.times ++
                    let obj = {
                        type: 'question',
                        currentId: this.currentId,
                        question: this.$route.query.prologue,
                        edit: false,
                    }
                    this.chatList.push(obj)
                    this.question = ''
                    return false
                }else{
                    let obj = {
                        type: 'answer',
                        currentId: this.currentId,
                        question: this.question,
                        edit: false,
                        questionScore: '',
                        needAddKnowledge: 3
                    }
                    this.chatList.push(obj)
                }
                let str = '', str1 = ''
                if(this.chatList.length > 1){
                    str = this.chatList[this.chatList.length-2]['question']
                    str1 = str + this.question
                }else{
                    str1 = this.chatList[this.chatList.length-1] + this.question
                }
                
                this.axios(
                    {
                        method:'get',
                        url:'/api/qa/predict?botId='+this.currentId+'&question1='+str1+'&question2='+this.question, 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        if(this.chatList[this.chatList.length-1]['type'] == 'answer'){
                            this.chatList[this.chatList.length-1]['questionScore'] = response.data.data.questionScore
                            this.chatList[this.chatList.length-1]['needAddKnowledge'] = response.data.data.needAddKnowledge
                        }
                        this.qaCount ++
                        this.question = ''
                        let obj = {}
                        if(response.data.data==null){
                            obj = {
                                type: 'question',
                                question: '空',
                                edit: false,
                                score: 0,
                                isShow: false,
                            }
                        }else{
                            obj = {
                                type: 'question',
                                question: response.data.data.answer,
                                edit: false,
                                score: response.data.data.score,
                                isShow: false,
                            }
                        }
                        // console.log(obj)
                        this.chatList.push(obj)
                        if(response.data.data.answer == ""){
                            this.answerNull = true
                            this.currentState = true
                            setTimeout(()=>{
                                this.placeholderWord = '机器人回复为空。无法输入，请先编辑。'
                            })
                        }else{
                            this.answerNull = false
                        }   
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cleanChat() {
                this.chatList = []
                this.question = this.$route.query.prologue
                this.times = 0
                this.placeholderWord = "请输入"
                this.answerNull = false
                this.currentState = false
                this.queryResponse()
            },
            editAnswer(item,index) {
                // console.log(item)
                // console.log(index)
                this.currentState = true
                this.currentAnswer = item.question
                this.chatList[index]['edit'] = true
            },
            sureAnswer(index) {
                this.currentState = true
                let question = this.chatList[index-2]['question']+this.chatList[index-1]['question']
                this.chatList[index]['edit'] = false
                this.chatList[index]['question'] = this.currentAnswer
                this.axios.post('/api/qa', {
                    botId: this.currentId,
                    question1: question,
                    question2: this.chatList[index-1]['question'],
                    answer: this.currentAnswer,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('操作成功') 
                        console.log(this.chatList)
                        console.log(index)
                        this.chatList[index-1]['needAddKnowledge'] = 1
                        this.currentState = false
                        this.answerNull = false
                        setTimeout(()=>{
                            this.placeholderWord = '请输入'
                        })
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            offAnswer(index) {
                this.chatList[index]['edit'] = false
                if(this.answerNull){
                    this.currentState = true
                }else{
                    this.currentState = false
                }
            },
            showLibrary(index) {
                event.stopPropagation(); 
                this.lastQuestion = this.chatList[index-2]['question']+this.chatList[index-1]['question']
                this.queryLibrary()
                this.randomNum ++
                this.chatList[index]['isShow'] = true
            },
            handleChange(value) {
                // console.log(`selected ${value}`);
                this.currentAnswer = value[0]
                for(let i = 0; i < this.chatList.length; i++){
                    this.chatList[i]['isShow'] = false
                }
            },
            queryLibrary() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/qa/predictList?botId='+this.currentId+'&question='+this.lastQuestion, 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.selectionList = response.data.data
                        this.$forceUpdate()
                        // console.log(this.selectionList)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            backTo() {
                this.$router.push({
                    path: "/RobotList",
                })
            },
            clickFn() {
                event.stopPropagation(); 
            },
            addIntoLib(index) {
                if(this.isLoading){
                    return false
                }
                this.isLoading = true
                this.axios.post('/api/qa/addKnowledge', {
                    botId: this.currentId,
                    question: this.chatList[index]['question'],
                    answer: this.chatList[index+1]['question'],
                })
                .then(response=> {
                    this.isLoading = false
                    if(response.data.code == 0){
                        this.$message.success('加入知识库成功') 
                        this.chatList[index]['needAddKnowledge'] = 2
                        this.chatList[index]['questionScore'] = 1
                        // console.log(this.chatList[index])
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            removeIntoLib(index) {
                if(this.isLoading){
                    return false
                }
                this.isLoading = true
                this.axios.post('/api/qa/removeKnowledge', {
                    botId: this.currentId,
                    question: this.chatList[index]['question'],
                })
                .then(response=> {
                    this.isLoading = false
                    if(response.data.code == 0){
                        this.$message.success('移出知识库成功') 
                        this.chatList[index]['needAddKnowledge'] = 1
                        this.chatList[index]['questionScore'] = 0
                        // console.log(this.chatList[index])
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            supportIdea(index) {
                if(this.isLoading){
                    return false
                }
                this.isLoading = true
                let question = this.chatList[index-2]['question']+this.chatList[index-1]['question']
                // console.log(question)
                // console.log(this.chatList[index-1]['question'])
                // console.log(this.chatList[index]['question'])
                this.axios.post('/api/qa/approve', {
                    botId: this.currentId,
                    question1: question,
                    question2: this.chatList[index-1]['question'],
                    answer: this.chatList[index]['question'],
                })
                .then(response=> {
                    this.isLoading = false
                    if(response.data.code == 0){
                        this.$message.success('点赞成功')
                        this.chatList[index-1]['questionScore'] = 1
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        mounted: function() {
            this.currentId = this.$route.query.id
            this.question = this.$route.query.prologue
            this.qaCount = this.$route.query.qaCount
            this.name = this.$route.query.name
            this.queryResponse()
            document.onclick = ()=> {
                // this.chatList[index]['isShow'] = true
                for(let i = 0; i < this.chatList.length; i++){
                    this.chatList[i]['isShow'] = false
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .chat-ul{
        .top-index{
            z-index: 1;
        }
        .color1{
            // background: rgba(160, 0, 0, 1);
            background: rgba(0, 159, 65, 1);
        }
        .color2{
            // background: rgba(229, 66, 10, 1);
            background: rgba(0, 159, 65, 1);
        }
        .color3{
            // background: rgba(238, 173, 0, 1);
            background: rgba(0, 159, 65, 1);
        }
        .color4{
            // background: rgba(67, 207, 124, 1);
            background: rgba(0, 159, 65, 1);
        }
        .color5{
            background: rgba(0, 159, 65, 1);
        }
        li{
            height: 80px;
            border-bottom: 1px solid rgba(204, 204, 204, 1);
            .add-box{
                // display: none;
                display: inline-block;
                width:80px;
                height:160px;
                border:1px solid rgba(204, 204, 204, 1);
                z-index:1000;
                background:#fff;
                text-align:center;
                font-size:14px;
                padding: 41px 16px 0;
                color:rgba(139, 152, 167, 1);
                cursor:pointer;
                float:left
            }
            .move-box{
                // display: none;
                display: inline-block;
                width:80px;
                height:160px;
                border:1px solid rgba(204, 204, 204, 1);
                z-index:1000;
                text-align:center;
                font-size:14px;
                padding: 41px 16px 0;
                color:rgba(212, 48, 48, 1);
                background:#ccc;
                cursor:pointer;
                float:left
            }
            .chat-list{
                width: 1100px;
                margin: auto;
                padding-top: 20px;
                position: relative;
                padding-left: 112px;
                .get-point{
                    color: #fff;
                    font-size: 14px;
                    position: absolute;
                    left: 42px;
                    top: 30px;
                }
                .like-dislike{
                    display: inline-block;
                    position: absolute;
                    left: 0px;
                    top: 30px;
                    padding-left: 35px;
                    // display: none;
                }
                .avatar{
                    width: 40px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 20px;
                    display: inline-block;
                    margin-right: 12px;
                }
                .avatar-robot{
                    background: rgba(24, 144, 255, 1);
                }
                .avatar-customer{
                    background: rgba(34, 215, 187, 1);
                }
                .content{
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                }
                .edit{
                    float: right;
                    font-size: 20px;
                    cursor: pointer;
                    margin-top: 10px;
                    display: none;
                }
                .btn-group{
                    float: right;
                    margin-top: 10px;
                    .btn-sure{
                        color: rgba(24, 144, 255, 1);
                        font-size: 14px;
                        cursor: pointer;
                        margin-right: 16px;
                    }
                    .btn-off{
                        color: rgba(139, 152, 167, 1);
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
            }
        }
        li:nth-of-type(odd){
            background: rgba(246, 246, 246, 1);
        }
        li:hover{
            .edit{
                display: inline-block;
            }
            // .like-dislike{
            //     display: inline-block;
            // }
            // .add-box{
            //     display: inline-block;
            // }
            // .move-box{
            //     display: inline-block;
            // }
        }
    }
</style>
